export const config = {
    entityKey: 'personas',
    titles: {
        singular: 'Persona',
        plural: 'Personas'
    }
}